var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.83366 4.99935C2.79199 6.39102 2.16699 8.12435 2.16699 9.99935C2.16699 14.5993 5.90033 18.3327 10.5003 18.3327C15.1003 18.3327 18.8337 14.5993 18.8337 9.99935C18.8337 5.39935 15.1003 1.66602 10.5003 1.66602C9.30866 1.66602 8.16699 1.91602 7.14199 2.37435",
    stroke: "#669F2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8.65065L13.9333 7.70898",
    stroke: "#669F2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.06641 10L9.34974 12.2917L11.4747 10.175",
    stroke: "#669F2A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.fd8e935d34877eda87671d12b6fcf3c4.svg";
export { ForwardRef as ReactComponent };